import type { Lead, LeadStage } from '@/types/database';

export type { Lead, LeadStage };

/** Estágios na ordem em que aparecem no Kanban. */
export const LEAD_STAGE_ORDER: LeadStage[] = [
  'new',
  'contacted',
  'proposal',
  'negotiation',
  'won',
  'lost',
];

export const LEAD_STAGE_LABELS: Record<LeadStage, string> = {
  new: 'Novo lead',
  contacted: 'Em contato',
  proposal: 'Proposta enviada',
  negotiation: 'Negociação',
  won: 'Ganho',
  lost: 'Perdido',
};

/** Cor do topo de cada coluna do funil. */
export const LEAD_STAGE_ACCENT: Record<LeadStage, string> = {
  new: 'bg-slate-400',
  contacted: 'bg-sky-500',
  proposal: 'bg-indigo-500',
  negotiation: 'bg-amber-500',
  won: 'bg-income',
  lost: 'bg-expense',
};
